import { Box, MenuItem, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Fragment, useContext, useEffect, useState } from 'react';
import { Button, Card, CardHeader, Col, Container, Modal, ModalBody, ModalHeader, Row, Table } from 'reactstrap';
import DataNotFound from '../../DataNoteFound/DataNotFound';
import Breadcrumbs from '../../layout/breadcrumb';
import TableSkeleton from '../../loader/TableSkeleton';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import { MuiTabelStyle } from '../../utils/helper';
import { useNavigate } from 'react-router';
import { classes } from '../../data/layouts';
import { ArrowLeft, Edit, List, Plus } from 'react-feather';
import BillManagementContext from '../../context/BillManagementContext/BillManagementContext';
import { Delete, Payment } from '@material-ui/icons';
import moment from 'moment';
import { Bill_Management_Detail } from '../../api/BillManagementApi/BillManagementApi';
import LogOut from '../../utils/logout';
import { toast, Zoom } from 'react-toastify';
import { ERROR_CODE } from '../../constant';
import PBTableMenuItem from './PBTableMenuItem';
const PaymentBillManagementItem = (props) => {
  const history = useNavigate();
  const defaultLayoutObj = classes.find((item) => Object.values(item).pop(1) === 'compact-wrapper');
  const layout = localStorage.getItem('layout') || Object.keys(defaultLayoutObj).pop();
  const {
    sorting,
    setPage,
    setPageSize,
    pageSize,
    page,
    record,
    AddModel,
    AddPaymentModel,
    showPaymentList,
    deleteHandle,
    editHandle
  } = props;
  const { billListValue } = useContext(BillManagementContext);
  const { responseLoader } = useContext(OrganizationContext);
  const [venderDeatils, setVenderDeatils] = useState({});
  const [previewImage, setPreviewImage] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const getVanderDetail = async () => {
    try {
      const { data } = await Bill_Management_Detail(props.vender);
      if (data.status === 200) {
        //ORG EDIT

        let payload = data.payload.data;
        setVenderDeatils(payload);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  const handleBack = () => {
    const url = `${process.env.PUBLIC_URL}/BillManagement/bill-management/${layout}`;
    history(url);
  };
  useEffect(() => {
    getVanderDetail();
  }, []);

  // -------------------------------
  // COLUMNS BASED ON NEW API
  // -------------------------------
  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 80,
      field: 'billImage',
      headerName: 'Bill Image',
      renderCell: (params) =>
        params.row.billImage ? (
          <img
            src={params.row.billImage}
            alt="Bill"
            className="img-thumbnail cursor-pointer"
            style={{ width: '80px', height: '80px', objectFit: 'cover' }}
            onClick={() => {
              setPreviewImage(params.row.billImage);
              setIsOpen(true);
            }}
          />
        ) : (
          '--'
        )
    },
    {
      flex: 0.15,
      minWidth: 100,
      field: 'totalAmount',
      headerName: 'Bill Amount',
      renderCell: (params) => (params.row.totalAmount ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(params.row.totalAmount) : '--')
    },
    {
      flex: 0.15,
      minWidth: 100,
      field: 'dueAmount',
      headerName: 'Due Amount',
      renderCell: (params) => (params.row.dueAmount ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(params.row.dueAmount) : '--')
    },
    {
      flex: 0.15,
      minWidth: 100,
      field: 'paidAmount',
      headerName: 'Paid Amount',
      renderCell: (params) => (params.row.paidAmount ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(params.row.paidAmount) : '--')
    },
    {
      flex: 0.15,
      minWidth: 100,
      field: 'notes',
      headerName: 'Bill Info',
      renderCell: (params) => (
        <Tooltip title={params.row.notes || ''}>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
            {params.row.notes ? params.row.notes : '--'}
          </span>
        </Tooltip>
      )
    },
    {
      flex: 0.15,
      minWidth: 100,
      field: 'status',
      headerName: 'Status',
      renderCell: (params) => (params.row.status ? params.row.status : '--')
    },
    {
      flex: 0.1,
      minWidth: 200,
      field: 'billDate',
      headerName: 'Bill Date',
      renderCell: (params) => (params.row.billDate ? moment(params.row.billDate).format('DD MMM YYYY, hh:mm A') : '--')
    },

    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      minWidth: 120,
      renderCell: (params) => (
        <div className="d-flex gap-2 align-items-center">
          <PBTableMenuItem
            params={params}
            editHandle={editHandle}
            deleteHandle={deleteHandle}
            AddPaymentModel={AddPaymentModel}
            showPaymentList={showPaymentList}
          />
          {/* <MenuItem onClick={() => deleteHandle(params.row.vendorId)}>
            <Delete style={{ color: 'red' }} />
          </MenuItem>
          <MenuItem
            onClick={() =>
              AddPaymentModel({
                vendorBillId: params.row.vendorBillId,
                dueAmount: params.row.dueAmount,
                totalAmount: params.row.totalAmount,
                paidAmount: params.row.paidAmount
              })
            }
          >
            <Payment style={{ color: 'purple' }} />
          </MenuItem>
          <MenuItem onClick={() => showPaymentList(params.row.vendorBillId)}>
            <List style={{ color: 'Green' }} />
          </MenuItem> */}
        </div>
      )
    }
  ];

  return (
    <Fragment>
      <Breadcrumbs parent="Accommodation Booking" />

      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}
              >
                <Button color="primary" onClick={handleBack}>
                  <ArrowLeft />
                </Button>
                <h3 style={{ margin: 0 }}>Add Bill</h3>
              </CardHeader>

              <Table>
                <thead>
                  <tr>
                    <th>
                      <Row>
                        <Col>Name: {venderDeatils.name}</Col>
                        <Col>Phone: {venderDeatils.phone}</Col>
                        <Col>Address: {venderDeatils.address}</Col>
                        <Col md="2 mb-2" className={'d-flex justify-content-end'}>
                          <Button color="primary" onClick={AddModel}>
                            <Plus />
                          </Button>
                        </Col>
                      </Row>
                    </th>
                  </tr>
                </thead>
              </Table>

              <Box
                sx={{
                  '& .even': { backgroundColor: '#f1f1f1' },
                  '& .odd': { backgroundColor: 'white' }
                }}
              >
                {responseLoader ? (
                  <TableSkeleton />
                ) : billListValue?.length ? (
                  <DataGrid
                    sx={MuiTabelStyle}
                    autoHeight
                    pagination
                    rows={billListValue}
                    rowCount={record}
                    pageSize={pageSize}
                    getRowId={(row) => row.vendorBillId || row.createdAt}
                    columns={defaultColumns}
                    page={page - 1}
                    rowsPerPageOptions={[7, 10, 25, 50]}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPageNo) => setPage(newPageNo + 1)}
                    paginationMode="server"
                    disableSelectionOnClick
                    sortingMode="server"
                    onSortModelChange={sorting}
                    getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
                  />
                ) : (
                  <DataNotFound />
                )}
              </Box>
            </Card>
          </Col>
        </Row>
        <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
          <ModalHeader toggle={toggle}>Bill Image</ModalHeader>
          <ModalBody className="text-center">
            <img src={previewImage} alt="Bill Preview" className="img-fluid rounded" />
          </ModalBody>
        </Modal>
      </Container>
    </Fragment>
  );
};

export default PaymentBillManagementItem;
